import { Injectable } from "@angular/core";
import { CacheService } from "../../gyzmo-commons/services/cache.service";
import { AttachmentWsDao } from "../dao/ws/attachment.ws.dao";
import { AttachmentDto } from "../dto/attachment.dto";
import { AttachmentKinds } from "../interfaces/attachmentKinds";
import { ServersConnectionsProvider } from "../providers/serversConnections.provider";

@Injectable({
    providedIn: "root",
})
export class AttachmentService {
    constructor(private attachmentWsDao: AttachmentWsDao,
                private cacheService: CacheService,
                private serversConnectionsProvider: ServersConnectionsProvider) {
    }

    public async cacheByCompanyId(companyId: string) {
        await this.attachmentWsDao.getByCompanyId(this.serversConnectionsProvider.getServerConnection(), companyId);
    }

    public getByDamageId(damageId: string, attachmentKind?: AttachmentKinds): Promise<AttachmentDto[]> {
        return this.attachmentWsDao.getByDamageId(this.serversConnectionsProvider.getPrimaryServerConnection(), damageId, attachmentKind);
    }

    public async getCGU(companyId: string): Promise<string> {
        let cacheId = "company/" + companyId + "/" + AttachmentKinds.CGU;
        if (await this.cacheService.isCached(cacheId)) {
            return (await this.cacheService.getCached(cacheId)).value;
        } else {
            return "";
        }
    }

    public async getCGL(companyId: string): Promise<string> {
        let cacheId = "company/" + companyId + "/" + AttachmentKinds.CGL;
        if (await this.cacheService.isCached(cacheId)) {
            return (await this.cacheService.getCached(cacheId)).value;
        } else {
            return "";
        }
    }

    public async getPrivacyPolicy(companyId: string): Promise<string> {
        let cacheId = "company/" + companyId + "/" + AttachmentKinds.POLITIQUE_CONFID;
        if (await this.cacheService.isCached(cacheId)) {
            return (await this.cacheService.getCached(cacheId)).value;
        } else {
            return "";
        }
    }

    public async getUserManual(): Promise<string> {
        let cacheId = "company/" + "IRIUM" + "/" + AttachmentKinds.MODE_EMPLOI;
        if (await this.cacheService.isCached(cacheId)) {
            return (await this.cacheService.getCached(cacheId)).value;
        } else {
            return "";
        }
    }

    public save(signatureTec: AttachmentDto) {
        return this.attachmentWsDao.save(this.serversConnectionsProvider.getServerConnection(), signatureTec);
    }
}
